import {Button, Card, CardBody, CardHeader, Input} from "reactstrap";
import React, {Component, Fragment} from "react";
import {deleteData, getData, patchData} from "../../api/doLogin";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import {isNumber} from "../../util/numberhelpers";
import {MakeDialog} from "../../components/Shared/MakeDialog";
import ReviewEntryEditor from "./ReviewEntryEditor";
import {EventClient} from "../../util/eventClient";
import {forceUTCTimeZone} from "../../util/datehelpers";
import {hasPermission, RequiredPermission} from "../../api/permissionHelper";
import {getGlobalState} from "../../constants/GlobalStore";

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

export class Reviews extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: false,
      data: [],
      formData: {},
      showIndicator: false,
      page: 1,
      limit: 30,
      when: "mtd",
      status: -1,
      loading: false,
      showAddReview: false,
      chosenReview: null,
      reviewStatus: 0
    }
    this.displayOptions = [
      {value: "mtd", display: "Month to Date"},
      {value: "lastmonth", display: "Last Month"},
      {value: "last30", display: "Last 30 Days"},
      {value: "last60", display: "Last 60 Days"},
      {value: "last90", display: "Last 90 Days"},
      {value: "ytd", display: "Year to Date"},
      {value: "lastyear", display: `Last Year (${(new Date()).getUTCFullYear() - 1})`},
      {value: "all", display: "All"},
    ];
    this.statusOptions = [
      {value: -1, display: "Any"},
      {value: 0, display: "Unapproved"},
      {value: 1, display: "Approved"},
    ]

    this.options = {
      defaultSortName: "dated",
      defaultSortOrder: "desc"
    }
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    const self = this;
    this.setState({loading: true}, () => {
      getData(`reviews/${self.state.when}`, {})
        .then((data) => {
          if (data.status === "Success") {
            self.setState({
              data: data.data.reviews,
              dataLoaded: true,
              showIndicator: false,
              loading: false
            });
          }
        })
        .catch(error => {
          console.error(error);
          self.setState({
            loading: false
          });
        });
    });
  }

  buttonFormatter(cell, row, context) {
    return <Fragment>
      <div/>
      {!row.status ?
        <Fragment>
          <Button color={"info"}
                  onClick={(evt) => {
                    context.setState({chosenReview: row.id, reviewStatus: row.status});
                  }}>Edit</Button>
          {(hasPermission(RequiredPermission.ReviewApprovalRemove) || row.uid === getGlobalState('loginID')) && (
            <Button color={"danger"}
                    onClick={(evt) => {
                      context.remove(row.id);
                    }}>Remove</Button>
          )}
        </Fragment>
        :
        <Button color={"info"}
                onClick={(evt) => {
                  context.setState({chosenReview: row.id, reviewStatus: row.status});
                }}>View</Button>
      }
      {hasPermission(RequiredPermission.ReviewApprovalRemove) && (
        <Button color={!row.status ? "success" : "warning"}
                onClick={(evt) => {
                  context.reviewApproval(row.id, !row.status ? 1 : 0)
                }}>{!row.status ? "Approve" : "Disapprove"}</Button>
      )}
    </Fragment>
  }

  reviewApproval(id, status) {
    const self = this;
    patchData(`reviews/${id}/status/${status}`, {})
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          EventClient.emit("TOAST_SUCCESS", "Status Saved Successfully");
          self.getData();
        } else {
          EventClient.emit('TOAST_ERROR', "Status could not be saved");
        }
      })
      .catch((err) => {
        EventClient.emit('TOAST_ERROR', "Status could not be saved");
      });
  }

  remove(id) {
    const self = this;
    if (!confirm("Are you sure you want to remove this review?")) return;
    deleteData(`reviews/${id}`, {})
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          self.getData();
        } else {
          EventClient.emit('TOAST_ERROR', "Status could not be removed");
        }
      })
      .catch((err) => {
        EventClient.emit('TOAST_ERROR', "Status could not be removed");
      });
  }

  updateStatus(lmsId, intakeId, status) {
    const self = this;
    // self.setState({loading: true}, () => {
    //
    //   patchData(`intakes/${lmsId || 0}/${intakeId || 0}/status/${status}`, {}, this.props.token)
    //     .then((data) => {
    //       // console.log(data);
    //       if (data.status === "Success") {
    //         self.setState({editStatus: null, editStatusValue: null}, () => {
    //           self.getData();
    //         });
    //         EventClient.emit("TOAST_SUCCESS", "Status Saved Successfully");
    //       } else {
    //         self.setState({loading: false, editStatus: null, editStatusValue: null});
    //         EventClient.emit("TOAST_ERROR", "Status not saved. Try later");
    //       }
    //     })
    //     .catch(error => {
    //       self.setState({loading: false, editStatus: null, editStatusValue: null});
    //       EventClient.emit("TOAST_ERROR", "Status not saved. Try later");
    //       console.error(error);
    //     });
    // });
  }

  updateAgency(lmsId, intakeId, agency) {
    const self = this;
    // self.setState({loading: true}, () => {
    //
    //   patchData(`intakes/${lmsId || 0}/${intakeId || 0}/agency/${agency}`, {}, this.props.token)
    //     .then((data) => {
    //       // console.log(data);
    //       if (data.status === "Success") {
    //         self.setState({editAgency: null, editAgencyValue: null}, () => {
    //           self.getData();
    //         });
    //         EventClient.emit("TOAST_SUCCESS", "Agency Saved Successfully");
    //       } else {
    //         self.setState({loading: false, editAgency: null, editAgencyValue: null});
    //         EventClient.emit("TOAST_ERROR", "Agency not saved. Try later");
    //       }
    //     })
    //     .catch(error => {
    //       self.setState({loading: false, editAgency: null, editAgencyValue: null});
    //       EventClient.emit("TOAST_ERROR", "Agency not saved. Try later");
    //       console.error(error);
    //     });
    // });
  }

  // displayAgency(agencyId, row) {
  //   let agencyText = "";
  //   if (this.state.agencies && this.state.agencies.length > 0) {
  //     let agency = this.state.agencies.find((agenc) => agenc.id === agencyId);
  //     agencyText = agency && agency.display || "Unknown"
  //   } else {
  //     agencyText = "Unknown";
  //   }
  //   if (row.id !== this.state.editAgency) {
  //     return <span>
  //       {agencyText}&nbsp;
  //       <i className="icon-pencil"
  //          onClick={() => this.setState({editAgencyValue: agencyId, editAgency: row.id})}
  //          title={"Change Agency"}
  //          style={{cursor: "pointer"}}/>
  //     </span>
  //   } else {
  //     return <div style={{display: "flex", alignItems: "center"}}>
  //       <Input
  //         type="select"
  //         id="agency"
  //         value={getFormFieldValue(this.state.editAgencyValue)}
  //         onChange={(evt) => {
  //           const value = evt.target.value;
  //           this.setState({editAgencyValue: value}, () => {
  //             this.updateAgency(row.lms_id, row.id, value)
  //           })
  //         }}
  //       >
  //         {this.state.agencies.map((agency, index) => {
  //           return <option key={index} value={agency.id}>{agency.display}</option>
  //         })}
  //       </Input>&nbsp;
  //       <i className="cil-action-undo"
  //          onClick={() => this.setState({editAgencyValue: null, editAgency: null})}
  //          title={"Cancel/Undo"}
  //          style={{cursor: "pointer"}}/>
  //     </div>
  //   }
  // }

  // displayStatus(cell, row) {
  //   if (row.id !== this.state.editStatus) {
  //     return <span>
  //       {TaxIntakeStatusList[cell]}&nbsp;
  //       <i className="icon-pencil"
  //          onClick={() => this.setState({editStatusValue: cell, editStatus: row.id})}
  //          title={"Change Status"}
  //          style={{cursor: "pointer"}}/>
  //     </span>
  //   } else {
  //     return <div style={{display: "flex", alignItems: "center"}}>
  //       <Input
  //         type="select"
  //         id="status"
  //         value={getFormFieldValue(this.state.editStatusValue)}
  //         onChange={(evt) => {
  //           const value = evt.target.value;
  //           this.setState({editStatusValue: value}, () => {
  //             this.updateStatus(row.lms_id, row.id, value)
  //           })
  //         }}
  //       >
  //         {TaxIntakeStatusList.map((display, value) => {
  //           return <option key={value} value={value}>{display}</option>
  //         })}
  //       </Input>&nbsp;
  //       <i className="cil-action-undo"
  //          onClick={() => this.setState({editStatusValue: null, editStatus: null})}
  //          title={"Cancel/Undo"}
  //          style={{cursor: "pointer"}}/>
  //     </div>
  //   }
  // }

  rowStyleFormat(row, rowIdx, self) {
    // if (!row || !row.updated) return {}
    // let dated = new Date(row.updated);

    // if (row.status < 4 && dated < self.backFive) return {backgroundColor: brandDanger};
    return {};
  }

  render() {
    return (
      <Card>
        {this.state.dataLoaded && (
          <Fragment>
            <CardHeader>
              <i className="icon-menu"/>Review Center

              <div className="card-actions" style={{display: "flex"}}>

                <div style={{display: "inline-flex", paddingRight: 25, paddingTop: 6}}>
                  <span style={{fontSize: 12, paddingTop: 12}}>When</span>
                  <Input type={"select"}
                         value={this.state.when}
                         onChange={(evt) => {
                           this.setState({when: evt.target.value}, () => this.getData());
                         }}
                  >
                    {/*<option key={-1} value={-1}>Any</option>*/}
                    {this.displayOptions.map(({display, value}, index) => {
                      return <option key={index} value={value}>{display}</option>
                    })}
                  </Input>
                </div>

                <div style={{display: "inline-flex", paddingRight: 25, paddingTop: 6}}>
                  <span style={{fontSize: 12, paddingTop: 12}}>Status</span>
                  <Input type={"select"}
                         value={this.state.status}
                         onChange={(evt) => {
                           this.setState({status: Number(evt.target.value)});
                         }}
                  >
                    {/*<option key={-1} value={-1}>Any</option>*/}
                    {this.statusOptions.map(({display, value}, index) => {
                      return <option key={index} value={value}>{display}</option>
                    })}
                  </Input>
                </div>

                <button onClick={() => this.setState({showAddReview: true, reviewStatus: 0})}>
                  <small className="text-muted">Add</small>
                </button>

                <button onClick={() => this.getData()}>
                  <small className="text-muted">Refresh</small>
                </button>

              </div>

            </CardHeader>
            <CardBody>
              <BootstrapTable data={this.state.data.filter((row) => {
                if (this.state.status === -1) return true;
                return row.status === this.state.status;
              })}
                              version="4" striped hover pagination search
                // trStyle={(row, ind) => this.rowStyleFormat(row, ind, this)}
                              options={this.options}>
                <TableHeaderColumn isKey={true} dataField="id" hidden>Id</TableHeaderColumn>
                <TableHeaderColumn dataField="LName" hidden>Id</TableHeaderColumn>
                <TableHeaderColumn dataField="FName" dataSort dataFormat={(cell, row) => {
                  return `${row.FName} ${row.LName}`;
                }}>Agent</TableHeaderColumn>
                <TableHeaderColumn dataField="customer" dataSort>Customer</TableHeaderColumn>
                {/*<TableHeaderColumn dataField="email" dataSort hidden>Email</TableHeaderColumn>*/}
                {/*<TableHeaderColumn dataField="ssn" dataSort hidden>SSN</TableHeaderColumn>*/}
                {/*<TableHeaderColumn dataField="agencyid" dataSort*/}
                {/*                   dataFormat={(cell, row) => this.displayAgency(cell, row)}>Agency</TableHeaderColumn>*/}
                {/*<TableHeaderColumn dataField="status" dataSort*/}
                {/*                   dataFormat={(cell, row) => this.displayStatus(cell, row)}>Status</TableHeaderColumn>*/}
                <TableHeaderColumn dataField="dated" dataSort dataFormat={(cell, row) => {
                  let dateStr = forceUTCTimeZone(new Date(cell));
                  return `${dateStr.toDateString()}`;
                }}>Received</TableHeaderColumn>
                <TableHeaderColumn width={"250px"}
                                   dataFormat={(cell, row) => this.buttonFormatter(cell, row, this)}>Actions</TableHeaderColumn>
              </BootstrapTable>
            </CardBody>
            {this.state.loading && (
              <div style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                paddingTop: 100,
                backgroundColor: "#fff",
                opacity: 0.5,
                top: 0,
                left: 0
              }}>
                <div className="sk-double-bounce" style={{opacity: 1}}>
                  <div className="sk-child sk-double-bounce1"></div>
                  <div className="sk-child sk-double-bounce2"></div>
                </div>
              </div>
            )}
            {(this.state.showAddReview || isNumber(this.state.chosenReview)) && (
              <MakeDialog isOpen={true}
                          size={"modal-lg"}
                          header="Review Entry"
                          footer={<Fragment>
                            {!this.state.reviewStatus && (
                              <Button color="primary"
                                      onClick={() => EventClient.emit("REVIEW_SAVE", {})}>Save</Button>
                            )}
                            {/*{!!this.state.chosenEvent && (*/}
                            {/*  <Button color="danger"*/}
                            {/*          onClick={() => this.removeEvent(this.state.chosenEvent)}>Delete</Button>*/}
                            {/*)}*/}
                            <Button color="secondary"
                                    onClick={() => this.getData() || this.setState({
                                      showAddReview: false,
                                      chosenReview: null,
                                      reviewStatus: 0
                                    })}>Close</Button>
                          </Fragment>}
              >
                <ReviewEntryEditor review={this.state.chosenReview || "add"}
                                   saveEvent={"REVIEW_SAVE"}
                                   eventName={"ReviewEntryEditor"}
                                   onSave={() => this.getData() || this.setState({
                                     showAddReview: false,
                                     chosenReview: null,
                                     reviewStatus: 0
                                   })}
                />
              </MakeDialog>
            )}
          </Fragment>
        )}
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Reviews/Reviews.js